import Inflector from 'ember-inflector';

/**
 * taken from https://github.com/storyhunter/sh-www/blob/d3e1f0183dd0d464c279670e9b5c088729431c52/sh-app/app/models/custom-inflector-rules.js
 */
export const initialize = () => {
  // Inflector.inflector.irregular('singular', 'plural');
  Inflector.inflector.irregular('urlmeta', 'urlmeta');
  Inflector.inflector.irregular('invoice-meta', 'invoice-meta');
  // Inflector.inflector.uncountable('baboonses');
};

export default {
  initialize,
};
